import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { ProductDetailPage } from "@/features/catalog/components/product-detail-page";

function ProductDetailRoutePage() {
  const params = catalogProductRoute.useParams();
  return <ProductDetailPage productId={params().productId} />;
}

export const catalogProductRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/catalog/$productId",
  component: ProductDetailRoutePage,
});
